// iOS WKWebView 네이티브 브릿지 통신 유틸리티
// Handler 이름: "settingsHandler" (iOS 팀과 공유 필요)

export type NativeSettingType = "zone" | "action" | "unit" | "sessionType"
export type NativeOperationType = "saving" | "create" | "update" | "delete" | "error"

export interface NativeBridgeMessage {
  type: "settingChanged"
  setting: NativeSettingType
  operation: NativeOperationType
}

declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        settingsHandler?: {
          postMessage: (data: NativeBridgeMessage) => void
        }
      }
    }
  }
}

/**
 * iOS WKWebView로 메시지 전송
 * handler가 없으면 no-op (브라우저에서도 안전)
 */
export function sendNativeMessage(message: NativeBridgeMessage): boolean {
  if (window.webkit?.messageHandlers?.settingsHandler) {
    try {
      window.webkit.messageHandlers.settingsHandler.postMessage(message)

      return true
    } catch (e) {
      console.warn("[NativeBridge] iOS postMessage failed:", e)

      return false
    }
  }

  return false
}

/**
 * 개발 환경에서 iOS 네이티브 브릿지 mock 등록
 * mode=webview일 때만 동작, 콘솔에 메시지 출력
 */
export function setupNativeBridgeDevMock() {
  if (!import.meta.env.DEV) {
    return
  }

  const isWebView = new URLSearchParams(window.location.search).get("mode") === "webview"

  if (!isWebView) {
    return
  }

  window.webkit = {
    messageHandlers: {
      settingsHandler: {
        postMessage: (data: NativeBridgeMessage) => {
          console.log("[NativeBridge Mock] iOS 메시지:", JSON.stringify(data, null, 2))
        },
      },
    },
  }
  console.log("[NativeBridge Mock] 개발용 mock handler 등록됨")
}
